<template>
    <v-container fluid>
        <v-card>
            <v-toolbar color="secondary" flat>
                <v-toolbar-title>Import Selling prices</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="primary" small text to="/import-price-lists">
                    <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <span class="style-24" style="color: red">{{ dataItem.Name }}</span>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="6">
                        <v-file-input name="productExcelFile" v-model="excelFile" label="Browse Price List Excel Sheet"
                            outlined dense></v-file-input>
                    </v-col>

                    <v-col cols="12">
                        <v-btn color="primary" @click="uploadExcel" :loading="loader">
                            <v-icon left>mdi-upload</v-icon>Upload Selling Prices
                        </v-btn>
                    </v-col>
                </v-row>

                <v-row>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                        hide-details></v-text-field>
                </v-row>

                <v-row class="subtitle-2 text--primary">
                    <v-col cols="12">
                        <v-data-table :headers="ShowBpSalesUi == 'Y' ? bpHeaders : headers" :items="priceListRows"
                            :search="search" :items-per-page="200">
                            <template v-slot:item.BuyingPrice="{ item }">
                                <span>{{ item.BuyingPrice.toLocaleString() }}</span>
                            </template>

                            <!-- selling price  -->
                            <template v-slot:item.SellingPrice="{ item }">
                                <span>{{ item.SellingPrice.toLocaleString() }}</span>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>

            </v-card-text>
        </v-card>

        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
    </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    components: {
    },
    computed: {
        ...mapGetters(["user"]),
    },
    data: () => ({
        search: "",
        ShowBpSalesUi: "",
        loader: false,
        excelFile: null,
        dataItem: {},
        priceListRows: [],
        docCreate: false,
        headers: [
            { text: "Product Name", value: "product.Name" },
            { text: "Selling Price", value: "SellingPrice" },
        ],
        bpHeaders: [
            { text: "Product Name", value: "product.Name" },
            { text: "Buying Price", value: "BuyingPrice" },
            { text: "Selling Price", value: "SellingPrice" },
        ],
    }),
    watch: {
        "$route.params.id": {
            handler: "getPriceList",
            immediate: true,
        },
    },
    methods: {
        getPriceList(val) {
            if (!val) {
                return;
            }

            const self = this;
            this.$store
                .dispatch("get", `/price-list/${val}`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.dataItem = res.ResponseData;
                        self.priceListRows = res.ResponseData.rows;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        uploadExcel() {
            this.loader = true;
            var priceListId = this.dataItem.id;
            var subscriberId = localStorage.getItem("subscriber_id");
            const formData = new FormData();
            formData.append("excelFile", this.excelFile);
            formData.append("pricelist_id", parseInt(priceListId));
            formData.append("subscriber_id", parseInt(subscriberId));
            this.loader = true;
            const self = this;
            this.$store
                .dispatch("post", {
                    url: `/price-list-import`,
                    data: formData
                })
                .then(res => {
                    if (res.ResultCode == 1200) {
                        this.$refs.snackbar.show(res.msg, "green");
                        self.loader = false;
                    } else {
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                        self.loader = false;
                    }
                    this.loader = false;
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                    this.loader = false;
                });
        },
        getGenSettings() {
            const self = this;
            this.$store.commit("loader", true);
            this.$store
                .dispatch("get", `/general-settings`)
                .then(res => {
                    if (res.ResultCode == 1200) {
                        self.ShowBpSalesUi = res.ResponseData.ShowBpSalesUi;

                        self.$store.commit("loader", false);
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch(err => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
    },
    created() {
        this.getPriceList();
        this.getGenSettings();
    },
};
</script>